<template>
  <div class="strategic-suitability-tab">
    <div class="tab-header">
      <h2>Strategic Suitability</h2>
      <p class="tab-description">
        Alignment with strategic objectives and priorities
      </p>
    </div>

    <form @submit.prevent="validateAndSubmit" class="project-form">
      
      <!-- Alignment with government priorities -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section A: Alignment with government priorities</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Does the project have high strategic importance and alignment with government priorities?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.strategicImportance" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.strategicImportance" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.strategicImportance" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.strategicImportance" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.strategicImportance" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="strategicImportanceComments">Comments</label>
            <textarea 
              id="strategicImportanceComments"
              v-model="formData.strategicImportanceComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Will the project lead to an improvement in service delivery?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceImprovement" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceImprovement" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceImprovement" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceImprovement" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceImprovement" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="serviceImprovementComments">Comments</label>
            <textarea 
              id="serviceImprovementComments"
              v-model="formData.serviceImprovementComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>
        </div>
        
        
      </section>

      <!-- Identification of service need -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section B: Identification of service need</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is there clear articulation and substantiation of the service deficiency?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceDeficiency" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceDeficiency" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceDeficiency" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceDeficiency" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceDeficiency" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="serviceDeficiencyComments">Comments</label>
            <textarea 
              id="serviceDeficiencyComments"
              v-model="formData.serviceDeficiencyComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Is the desired service outcome well defined and can it be used to scope out the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceOutcome" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceOutcome" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceOutcome" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceOutcome" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.serviceOutcome" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="serviceOutcomeComments">Comments</label>
            <textarea 
              id="serviceOutcomeComments"
              v-model="formData.serviceOutcomeComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Is there a consensus on users' and stakeholders' expectations from the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.stakeholderConsensus" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.stakeholderConsensus" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.stakeholderConsensus" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.stakeholderConsensus" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.stakeholderConsensus" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="stakeholderConsensusComments">Comments</label>
            <textarea 
              id="stakeholderConsensusComments"
              v-model="formData.stakeholderConsensusComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Assessment of service delivery options -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section C: Assessment of service delivery options</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Has there been an assessment of all possible technical solutions to address the identified need?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSolutions" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSolutions" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSolutions" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSolutions" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSolutions" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="technicalSolutionsComments">Comments</label>
            <textarea 
              id="technicalSolutionsComments"
              v-model="formData.technicalSolutionsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Does the technical solution clearly address the service need in a cost-effective and affordable manner?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEffectiveSolution" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEffectiveSolution" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEffectiveSolution" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEffectiveSolution" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEffectiveSolution" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="costEffectiveSolutionComments">Comments</label>
            <textarea 
              id="costEffectiveSolutionComments"
              v-model="formData.costEffectiveSolutionComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Scoping of the Project -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section D: Scoping of the project</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is there a clear description of the technical features of the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalFeatures" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalFeatures" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalFeatures" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalFeatures" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalFeatures" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="technicalFeaturesComments">Comments</label>
            <textarea 
              id="technicalFeaturesComments"
              v-model="formData.technicalFeaturesComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Is the user base identified for the project in terms of users, geography, growth trends, etc.?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.userBase" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.userBase" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.userBase" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.userBase" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.userBase" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="userBaseComments">Comments</label>
            <textarea 
              id="userBaseComments"
              v-model="formData.userBaseComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Are the project outputs defined, measurable and verifiable?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectOutputs" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectOutputs" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectOutputs" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectOutputs" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectOutputs" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="projectOutputsComments">Comments</label>
            <textarea 
              id="projectOutputsComments"
              v-model="formData.projectOutputsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4.Does the scoping cover the entire term of the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectTermCoverage" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectTermCoverage" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectTermCoverage" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectTermCoverage" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.projectTermCoverage" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="projectTermCoverageComments">Comments</label>
            <textarea 
              id="projectTermCoverageComments"
              v-model="formData.projectTermCoverageComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

    </form>
  </div>
</template>

<script>
export default {
  name: 'StrategicSuitabilityTab',
  props: {
    projectData: {
      type: Object,
      default: () => ({})
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        strategicImportance: '',
        strategicImportanceComments: '',
        serviceImprovement: '',
        serviceImprovementComments: '',
        serviceDeficiency: '',
        serviceDeficiencyComments: '',
        serviceOutcome: '',
        serviceOutcomeComments: '',
        stakeholderConsensus: '',
        stakeholderConsensusComments: '',
        technicalSolutions: '',
        technicalSolutionsComments: '',
        costEffectiveSolution: '',
        costEffectiveSolutionComments: '',
        technicalFeatures: '',
        technicalFeaturesComments: '',
        userBase: '',
        userBaseComments: '',
        projectOutputs: '',
        projectOutputsComments: '',
        projectTermCoverage: '',
        projectTermCoverageComments: ''
      },
      errors: {},
      showValidation: false
    }
  },
  computed: {
    isValid() {
      return this.validateForm().isValid
    },
    isSectionComplete() {
      // Section is complete when all questions are answered
      return this.formData.strategicImportance && 
             this.formData.serviceImprovement &&
             this.formData.serviceDeficiency &&
             this.formData.serviceOutcome &&
             this.formData.stakeholderConsensus &&
             this.formData.technicalSolutions &&
             this.formData.costEffectiveSolution &&
             this.formData.technicalFeatures &&
             this.formData.userBase &&
             this.formData.projectOutputs &&
             this.formData.projectTermCoverage
    }
  },
  watch: {
    projectData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.formData = { ...this.formData, ...newData }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateData() {
      this.$emit('update', this.formData)
      this.validateForm()
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      this.showValidation = true
      this.$emit('validate', isValid)
      
      return { isValid, errors: this.errors }
    },
    validateAndSubmit() {
      this.validateForm()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.validateForm()
    })
  }
}
</script>

<style scoped>
.strategic-suitability-tab {
  max-width: 1000px;
  margin: 0 auto;
}

.tab-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}

.tab-header h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.tab-description {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.form-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border-left: 4px solid #00338d;
}

.section-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.section-header h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.section-description {
  color: #666;
  font-size: 0.95rem;
  font-style: italic;
}

.validation-status {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}

.validation-success {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #28a745;
  font-weight: 600;
}

.validation-success svg {
  flex-shrink: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e0e6ed;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: white;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-group textarea:focus {
  outline: none;
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
}

.checkbox-label {
  display: block !important;
}

.checkbox-text {
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  display: block;
}

.radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
  align-items: stretch;
}

.radio-group.yes-no {
  grid-template-columns: repeat(2, minmax(80px, 120px));
  justify-content: start;
}

.radio-option {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  padding: 0.75rem 1rem;
  min-height: 40px;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 8px;
  border: 2px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  text-align: center;
}

.radio-option input[type="radio"] {
  display: none;
}

.radio-option:has(input[type="radio"]:checked) {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

/* Fallback for browsers that don't support :has() */
.radio-option.selected {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

.radio-option.selected:hover {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:hover {
  background-color: #e8f0fe;
  border-color: #00338d;
  color: #00338d;
}

.radio-option:hover:has(input[type="radio"]:checked) {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:has(input[type="radio"]:focus) {
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
  outline: none;
}

.radio-option:has(input[type="radio"]:focus-visible) {
  outline: 2px solid #00338d;
  outline-offset: 2px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .radio-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .radio-option {
    padding: 0.75rem 0.75rem;
    min-height: 44px;
    font-size: 0.95rem;
  }
  
  .form-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .radio-group {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .radio-option {
    padding: 1rem 0.75rem;
    min-height: 48px;
    font-size: 0.9rem;
  }
}
</style>